<template>
  <div class="page-slot">
    <img :src="prospData.data.camera.url" class="facestream-frame" />
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";

export default {
  props: {
    data: {
      type: Object,
    },
  },
  setup(props) {
    const prospData = ref(props);

    return {
      prospData,
    };
  },
};
</script>

<style lang="scss" scoped>
.facestream-frame {
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
}

.page-slot {
  width: 100%;
  height: 100%;
}

</style>
